import { VariaveisAmbiente } from 'config';
import { FaturaModel } from 'model/api/gestao/fatura/fatura-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetFaturaById() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<FaturaModel>();

    const getFaturaById = useCallback(
        (faturaId: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Fatura/${faturaId}`,
                method: 'GET',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getFaturaById,
    };
}
